import { call, put, takeLatest, select, all } from 'redux-saga/effects';
import _ from 'lodash';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import SharedUtils from '../utils/SharedUtils';
import { REORDER_FETCH_MENU, REORDER_FETCH_MENU_ERROR, REORDER_FETCH_MENU_SUCCESS, REORDER_STORE_STATUS, REORDER_STORE_STATUS_ERROR, REORDER_STORE_STATUS_SUCCESS, RE_ORDER_ACCEPTED_ERROR, RE_ORDER_ACCEPTED, RE_ORDER_ACCEPTED_SUCCESS, } from '../constants';
import Strings from '../constants/Strings';
export function* StoreStatusApiCall(request) {
    try {
        const { payload, successCallback, errorCallback } = request;
        const { data, tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const networkObject = _.get(networkConfig, Strings.bulkStore);
        const response = yield call(invokeApi, networkObject, null, headers, data);
        if (response.status >= 400) {
            yield put(setErrorCode(response.status));
        }
        if (response) {
            const { response: resArray = [] } = response;
            yield put({
                type: REORDER_STORE_STATUS_SUCCESS,
                storeStatus: resArray[0] || {},
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: REORDER_STORE_STATUS_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: REORDER_STORE_STATUS_ERROR,
        });
    }
}
export function* reorderStoreStatusApiSaga() {
    yield takeLatest(REORDER_STORE_STATUS, StoreStatusApiCall);
}
export function* reorderFetchMenu(menuParam) {
    try {
        const { successCallback, menuPayload, exclusionPayload } = menuParam;
        const menuConfig = networkConfig.menu;
        const menuData = {
            queryProps: menuPayload,
        };
        const { channel = '', storeId = '', service = '' } = exclusionPayload;
        const tenantReducer = yield select((state) => state.tenantReducer);
        const allowScheduleOrderForDispositions = tenantReducer?.componentOptions?.[channel]?.scheduledDelivery?.allowScheduleOrderForDispositions ?? [];
        let exclusionConfig = networkConfig.exclusions;
        const futureExclusionsCall = SharedUtils.futureMenuExclusionCall(exclusionPayload, allowScheduleOrderForDispositions);
        let payload = null;
        let exclusionData = {};
        const header = { 'x-tenant-id': menuPayload?.tenantId };
        const menuAndExclusionCall = [call(invokeApi, menuConfig, menuData)];
        if (storeId?.length > 0 && service) {
            exclusionData = {
                queryProps: exclusionPayload,
            };
            if (futureExclusionsCall) {
                exclusionConfig = networkConfig.futureExclusions;
                exclusionData = {};
                payload = exclusionPayload;
            }
            menuAndExclusionCall.push(call(invokeApi, exclusionConfig, exclusionData, header, payload));
        }
        const [menuResponse, ...exclusionsResponse] = yield all(menuAndExclusionCall);
        if (menuResponse.status >= 400) {
            yield put(setErrorCode(menuResponse.status));
        }
        if (exclusionsResponse[0] && exclusionsResponse[0].status >= 400) {
            yield put(setErrorCode(exclusionsResponse.status));
        }
        const getTenant = (state) => state.tenantReducer;
        const tenantData = yield select(getTenant);
        const tenantDateFormat = tenantData.dateFormat;
        if (menuResponse?.response && exclusionsResponse && tenantDateFormat) {
            yield put({
                type: REORDER_FETCH_MENU_SUCCESS,
                menuResponse: menuResponse.response,
                exclusionsResponse: exclusionsResponse[0]?.response ? [exclusionsResponse[0].response] : [],
                tenantDateFormat,
            });
            successCallback && successCallback();
        }
        else {
            yield put({
                type: REORDER_FETCH_MENU_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: REORDER_FETCH_MENU_ERROR,
        });
    }
}
export function* reorderMenuSaga() {
    yield takeLatest(REORDER_FETCH_MENU, reorderFetchMenu);
}
export function* reorderAcceptedCall(data) {
    const { payload, successCallback } = data;
    const { orderId, tenantId, customerId } = payload;
    const headers = {
        'x-tenant-id': tenantId,
        'x-is-registered-user': true,
        'x-user-id': customerId,
        'Content-Type': 'application/json',
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.postOrderAccepted, { queryProps: { orderId: orderId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: RE_ORDER_ACCEPTED_SUCCESS,
                response,
            });
            successCallback && successCallback();
        }
        else {
            yield put({
                type: RE_ORDER_ACCEPTED_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: RE_ORDER_ACCEPTED_ERROR,
        });
    }
}
export function* reOrderAcceptedSaga() {
    yield takeLatest(RE_ORDER_ACCEPTED, reorderAcceptedCall);
}
